import { __assign, __generator } from "tslib";
import { select, call, takeEvery, all } from 'redux-saga/effects';
import { logger } from '../BiLogger.logger';
import { logPageView } from './actions';
import { getPublicSession } from '../../publicSession/selectors';
import { BiEventType } from '../constants';
import { getBiContextData } from './selectors';
// helper for logging events from sagas
export function logBiEvent(data, isPageView) {
    var contextData;
    if (isPageView === void 0) { isPageView = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(isPageView ? getPublicSession : getBiContextData)];
            case 1:
                contextData = _a.sent();
                return [4 /*yield*/, call([logger, 'log'], contextData, data)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleLogPageView(_a) {
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(logBiEvent, __assign({ evid: BiEventType.PAGEVIEW }, payload), true)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([takeEvery(logPageView, handleLogPageView)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map